import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '../../../components/atomic/Buttons/Button';
import FileUploader from '../../../components/atomic/Inputs/FileUploader';
import VideoSelect from '../../../components/molecule/FormFields/VideoSelect';
import TextInput from '../../../components/molecule/FormFields/TextInput';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import * as apiServices from '../../../services/apiServices';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import { startAudioPolling, startPolling } from '../../../modules/UploadQueue';
import { toast } from 'react-toastify';
import StatusButton from '../../../components/molecule/StatusIndicators/StatusButton';
import { AlertModal } from '../../../components/molecule/Modals/AlertModal';
import {
  ACCEPTED_AUDIO_FORMATS,
  ACCEPTED_VIDEO_FORMATS,
  LIMITS,
  STREAMING_STATUS,
} from '../../../core/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  min-width: 800px;
`
const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 30px 10px;
`
const StretchContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
`
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`

const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`

const InputStyled = styled(Input)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`
const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`
const Image = styled.img`
  max-width: 10%;
  max-height: 10%;
  transform: scale(10);
`
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`
const IconStyled = styled(Icon)`
  color: white;
`

const DropContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: flex-end;
  height: 1px;
  z-index: 1;
`

const RemoveIconStyled = styled(Button)`
  position: absolute;
  padding: 0;
  right: 0;
  min-width: 40px;
  max-width: 40px;
  height: 40px;
`

const Aside = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

const InfoContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex: 3;
  ${'' /* margin: 3px; */}
  margin-top: 10px;
  padding: 10px 15px;
  margin-bottom: auto;
`
const HeaderContainer = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 10px 0;
`
const FormStyled = styled(Form)`
  display: flex;
`
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // height: 160px;
`
const Header = styled.div`
  // background: rgba(0,0,0,0.1);
  font-size: 20px;
  font-weight: 600;
  `
/*
const SubHeader = styled.div`
  // background: rgba(0,0,0,0.1);
  // margin: 3px;
  margin-top: 4px;
  font-size: 14px;
`
*/
const OptionSelect = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const UploadButtonContainer = styled.div`
  
`
const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
`
const StatusButtonStyled = styled(StatusButton)`
  margin: 10px 0 0 auto;
`
const TextInputStyled = styled(TextInput)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`

class ActivityForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      audioUploadProgress: 0,
      imageUploadProgress: 0,
      videoUploadProgress: 0,
    }
  }
  
  componentDidUpdate(prevProps) {
    const {
      activityAudioFiles: prevActivityAudioFiles,
      activityVideos: prevActivityVideos,
    } = prevProps.uploadQueueState;

    const {
      uploadQueueState: { activityAudioFiles, activityVideos },
      values,
    } = this.props;

    if (prevActivityVideos && activityVideos &&
        prevActivityVideos[values.id] && activityVideos[values.id] &&
        prevActivityVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
        activityVideos[values.id].streaming_status === STREAMING_STATUS.COMPLETE) {

      // ...values.video,
      this.changeTracker({
        id: activityVideos[values.id].videoId,
        thumbnail: activityVideos[values.id].thumbnail,
        streaming_status: activityVideos[values.id].streaming_status,
        video: activityVideos[values.id].streaming_video,
      }, 'video');
    }

    if (prevActivityAudioFiles && activityAudioFiles &&
        prevActivityAudioFiles[values.id] && activityAudioFiles[values.id] &&
        prevActivityAudioFiles[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
        activityAudioFiles[values.id].streaming_status === STREAMING_STATUS.COMPLETE) {

      // ...values.audio,
      this.changeTracker({
        id: activityAudioFiles[values.id].audioId,
        streaming_status: activityAudioFiles[values.id].streaming_status,
        audio: activityAudioFiles[values.id].streaming_audio,
      }, 'audio');
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  removeAudio = () => this.changeTracker(null, 'audio')
  removeVideo = () => this.changeTracker(null, 'video')
  removeImage = () => this.changeTracker(null, 'image')

  imageUploadFinished = ({ awsUrl }) => {
    apiServices.addOverviewImage({ url: awsUrl })
      .then(data => {
        toast.success('image uploaded successfully');
        this.changeTracker({id: data.id, url: data.url}, 'image');
        this.setState({ imageUploadProgress: 0 });
      });
  }
  updateImageUploadProgress = (imageUploadProgress) => {
    this.setState({ imageUploadProgress });
  }

  videoUploadFinished = ({ awsUrl }) => {
    const { startPolling, values } = this.props;

    apiServices.addOverviewVideo({
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
    }).then(data => {
      this.setState({ videoUploadProgress: 0 });
      startPolling({
        id: values.id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'activityVideos'
      });
    });
  }
  updateVideoUploadProgress = (videoUploadProgress) => {
    this.setState({ videoUploadProgress });
  }

  audioUploadFinished = ({ awsUrl }) => {
    const { startAudioPolling, values } = this.props;

    apiServices.addOverviewAudio({
      streaming_status: STREAMING_STATUS.PROCESSING,
      audio: awsUrl,
    }).then(data => {
      this.setState({ audioUploadProgress: 0 });
      startAudioPolling({
        id: values.id,
        audioId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'activityAudioFiles'
      });
    });
  }
  updateAudioUploadProgress = (audioUploadProgress) => {
    this.setState({ audioUploadProgress });
  }

  render () {
    const {
      authState: { userData },
      values,
      uploadQueueState: { activityAudioFiles, activityVideos },
    } = this.props
    const {
      audioUploadProgress,
      imageUploadProgress,
      videoUploadProgress,
    } = this.state;

    return (
      <FormStyled>
        <Container>
          <Wrapper>
            <StatusButtonStyled
              value={values}
              header="Complete Activity"
              subheader="Activity is complete when the tasks below are complete."
            />
            <StretchContainer>
              <Aside>
                <ImageContainer>
                  <UploadButtonContainer>
                    <FileUploader
                      accept='image/*'
                      buttonText="Upload Image"
                      fileType="image"
                      fullWidth
                      onFinish={this.imageUploadFinished}
                      onProgress={this.updateImageUploadProgress}
                      variant='contained'
                    />
                  </UploadButtonContainer>
                  {
                        values.image ? (
                          <React.Fragment>
                            <DropContainer>
                              <RemoveIconStyled variant='contained' color="secondary" onClick={() => AlertModal('Delete Image','Are you sure you want to delete this image?', this.removeImage)}>
                                <IconStyled>delete_forever</IconStyled>
                              </RemoveIconStyled>
                            </DropContainer>
                            <ImageWrapper>
                              <Image src={values.image.url} alt='activity picture'/>
                            </ImageWrapper>
                          </React.Fragment>
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                            No Image
                          </ImageWrapper>
                        )
                      }
                  { imageUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={imageUploadProgress} />
                    </UploadProgressContainer>
                  )}
                </ImageContainer>
                <VideoContainer>
                  <UploadButtonContainer>
                    <FileUploader
                      accept={ACCEPTED_VIDEO_FORMATS}
                      buttonText="Upload Video"
                      fileType="video"
                      fullWidth
                      metadata={{ trainer_id: userData.user_id.toString() }}
                      onFinish={this.videoUploadFinished}
                      onProgress={this.updateVideoUploadProgress}
                      variant='contained'
                    />
                  </UploadButtonContainer>
                  <OptionWrapper>
                    <OptionSelect>
                      {
                        values.video ? (
                          <VideoSelectStyled
                            onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', this.removeVideo)}
                            processing={(activityVideos[values.id] && activityVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING)}
                            thumbnail={values.video.thumbnail}
                            video={values.video.video}
                          />
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                            No Video
                            {
                              activityVideos[values.id] && activityVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
                                <CircularProgress />
                            }
                          </ImageWrapper>
                        )
                      }
                    </OptionSelect>
                  </OptionWrapper>
                  { videoUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={videoUploadProgress} />
                    </UploadProgressContainer>
                  )}
                </VideoContainer>

                <VideoContainer>
                  <UploadButtonContainer>
                    <FileUploader
                      accept={ACCEPTED_AUDIO_FORMATS}
                      buttonText="Upload Audio"
                      fileType="audio"
                      fullWidth
                      metadata={{ audio_only: "true", trainer_id: userData.user_id.toString() }}
                      onFinish={this.audioUploadFinished}
                      onProgress={this.updateAudioUploadProgress}
                      variant='contained'
                    />
                  </UploadButtonContainer>
                  <OptionWrapper>
                    <OptionSelect>
                      {
                        values.audio ? (
                          <VideoSelectStyled
                            onDelete={() => AlertModal('Delete Audio','Are you sure you want to delete this audio?', this.removeAudio)}
                            processing={(activityAudioFiles[values.id] && activityAudioFiles[values.id].streaming_status === STREAMING_STATUS.PROCESSING)}
                            video={values.audio.audio}
                          />
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>headphones</PlaceholderIconStyled>
                            No Audio
                            {
                              activityAudioFiles[values.id] && activityAudioFiles[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
                                <CircularProgress />
                            }
                          </ImageWrapper>
                        )
                      }
                    </OptionSelect>
                  </OptionWrapper>
                  { audioUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={audioUploadProgress} />
                    </UploadProgressContainer>
                  )}
                </VideoContainer>

              </Aside>
              <InfoContainer>
                <HeaderContainer>
                  <Header>Activity Name</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  onChange={(e) => this.changeTracker(e.target.value, 'name')}
                  value={values.name}
                />
                <HeaderContainer>
                  <Header>Activity Type</Header>
                </HeaderContainer>
                <Select
                  value={values.activity_type}
                  onChange={(e) => this.changeTracker(e.target.value, 'activity_type')}
                  inputProps={{ name: 'activity_type', id: 'activity-type', }}
                >
                  <MenuItem value="recovery">Recovery</MenuItem>
                  <MenuItem value="fun">Fun</MenuItem>
                  <MenuItem value="mental wellness">Mental Wellness</MenuItem>
                  <MenuItem value="winner's mindset">Winner's Mindset</MenuItem>
                </Select>
                <HeaderContainer>
                  <Header>Description</Header>
                </HeaderContainer>
                <TextInputStyled
                  type="text"
                  placeholder="Enter activity description..."
                  onChange={(val) => this.changeTracker(val, 'description')}
                  value={values.description}
                  maxLength={LIMITS.activities.description}
                />
                <HeaderContainer>
                  <Header>External Link</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  onChange={(e) => this.changeTracker(e.target.value, 'external_link')}
                  value={values.external_link}
                />
                <HeaderContainer>
                  <Header>External Link Description</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  onChange={(e) => this.changeTracker(e.target.value, 'external_link_description')}
                  value={values.external_link_description}
                  disabled={!values.external_link}
                />
                <HeaderContainer>
                  <Header>Audio Description</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  onChange={(e) => this.changeTracker(e.target.value, 'audio_description')}
                  value={values.audio_description}
                  disabled={!values.audio}
                />
              </InfoContainer>
            </StretchContainer>
          </Wrapper>
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    uploadQueueState: state.uploadQueueState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
    startAudioPolling: startAudioPolling,
    startPolling: startPolling,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
  }),

  validate: (values, props) => {
    props.submit(values);
  },

  displayName: 'ActivityForm',
}))(ActivityForm);
